import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { Container, Grid, Menu as BaseMenu, Loader } from 'semantic-ui-react';
import { Divider, PageHeader } from '../../../components';
import { GET_MEMBERSHIPS_QUERY } from '../containers/queries';
import CreateMembershipButton from './CreateMembershipButton';
import MembershipList from './MembershipList';

const Menu = styled(BaseMenu)`
    &.menu {
        margin: -0.5em -1em !important;
    }
`;

const MembershipsPageView = ({ memberships }) => (
    <Container fluid>
        <Menu secondary>
            <BaseMenu.Item header>
                <PageHeader>
                    <FormattedMessage
                        id="navbar.menu.memberships"
                        defaultMessage="Memberships"
                    />
                </PageHeader>
            </BaseMenu.Item>
            <BaseMenu.Menu position="right">
                <BaseMenu.Item>
                    <CreateMembershipButton memberships={memberships} />
                </BaseMenu.Item>
            </BaseMenu.Menu>
        </Menu>
        <Divider />
        <Grid columns={1}>
            <Grid.Column>
                <MembershipList memberships={memberships} />
            </Grid.Column>
        </Grid>
    </Container>
);

function MembershipsPage() {
    const salon = useSelector(({ user }) => user.get('salon'));
    const currentLanguage = useSelector(
        ({ intl }) => intl.get('locale') || intl.get('defaultLanguage'),
    );
    const { loading, data } = useQuery(GET_MEMBERSHIPS_QUERY, {
        variables: { salon, lang: currentLanguage },
        fetchPolicy: 'cache-and-network',
    });
    if (loading) return <Loader size="big" inline="centered" active />;
    const memberships = data?.viewer?.salon?.memberships ?? [];
    return <MembershipsPageView memberships={memberships} />;
}

export default MembershipsPage;
